import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import ImageLoader from '../images/ImageLoader';
import Modal from '../modal/Modal';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { loyaltyDuck } from '../../ducks/loyalty';
import { AuthenticationState } from 'react-aad-msal';
import { useFlags } from 'launchdarkly-react-client-sdk';

var DailyTransactionLimitReachedModal = function DailyTransactionLimitReachedModal(props) {
  var _props$loyalty2, _props$loyalty2$trans, _props$loyalty3;

  var flags = useFlags();
  var ldTransactionLimitModalAvailable = flags['releaseWebDailyTransactionLimitReachedModal'] ? flags['releaseWebDailyTransactionLimitReachedModal'] : false;
  var _props$model = props.model,
      model = _props$model === void 0 ? {} : _props$model,
      authenticationState = props.authenticationState;
  var image = model.image,
      headline = model.headline,
      copy = model.copy,
      button = model.button;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var handleHide = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsOpen(false);
              _context.prev = 1;
              _context.next = 4;
              return props.setTransactionLimitInfo({
                showTransactionLimitModal: false
              });

            case 4:
              _context.next = 9;
              break;

            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](1);
              console.error('Error closing modal', _context.t0.message);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 6]]);
    }));

    return function handleHide() {
      return _ref.apply(this, arguments);
    };
  }();

  useEffect(function () {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _props$loyalty, _props$loyalty$transa;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (authenticationState !== AuthenticationState.Authenticated) {
                setIsOpen(false);
              } else {
                if (ldTransactionLimitModalAvailable && ((_props$loyalty = props.loyalty) === null || _props$loyalty === void 0 ? void 0 : (_props$loyalty$transa = _props$loyalty.transactionLimitInfo) === null || _props$loyalty$transa === void 0 ? void 0 : _props$loyalty$transa.showTransactionLimitModal) === true && !props.loyalty.showPersonalizationModal) {
                  setIsOpen(true);
                }

                if (!ldTransactionLimitModalAvailable) {
                  setIsOpen(false);
                }
              }

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }, [(_props$loyalty2 = props.loyalty) === null || _props$loyalty2 === void 0 ? void 0 : (_props$loyalty2$trans = _props$loyalty2.transactionLimitInfo) === null || _props$loyalty2$trans === void 0 ? void 0 : _props$loyalty2$trans.showTransactionLimitModal, (_props$loyalty3 = props.loyalty) === null || _props$loyalty3 === void 0 ? void 0 : _props$loyalty3.showPersonalizationModal]); // Uncomment this to test on storybook

  /*useEffect(() => {
    (async () => {
      await props.setTransactionLimitInfo({
        showTransactionLimitModal: true
      })
    })()
  }, [])*/

  return /*#__PURE__*/React.createElement(Modal, {
    className: 'loyalty-modal loyalty-modal--daily-transaction-limit-reached',
    show: isOpen,
    hide: handleHide,
    hideCloseButton: true,
    backdrop: true,
    noHeader: true
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-daily-transaction-limit-reached-modal'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-daily-transaction-limit-reached-modal__image-container'
  }, /*#__PURE__*/React.createElement(ImageLoader, {
    media: image,
    type: 'product',
    className: "cb-card__image"
  })), /*#__PURE__*/React.createElement("div", {
    className: 'cb-daily-transaction-limit-reached-modal__body-container'
  }, /*#__PURE__*/React.createElement(Text, {
    tag: 'span',
    className: 'cb-daily-transaction-limit-reached-modal__body-container__header',
    field: headline
  }), /*#__PURE__*/React.createElement(RichText, {
    field: copy,
    tag: "span",
    className: 'cb-daily-transaction-limit-reached-modal__body-container__copy'
  }), /*#__PURE__*/React.createElement(Button, {
    className: "cb-button-primary cb-daily-transaction-limit-reached-modal__body-container__button",
    onClick: handleHide
  }, button === null || button === void 0 ? void 0 : button.value))));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    loyalty: state.loyalty
  };
};

var loyaltyOperations = loyaltyDuck.operations;

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setTransactionLimitInfo: function setTransactionLimitInfo(show) {
      return dispatch(loyaltyOperations.setTransactionLimitInfo(show));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DailyTransactionLimitReachedModal);